module.exports = __webpack_public_path__ + "img/service-03.557eb4dd.svg";